/** Same number as site WhatsApp float button */
export const WHATSAPP_PHONE = '918650960313';

export function buildWhatsAppUrl(text) {
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(text)}`;
}

export function openWhatsApp(text) {
  const url = buildWhatsAppUrl(text);
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened || typeof opened.closed === 'undefined' || opened.closed) {
    window.location.assign(url);
  }
}

export function buildContactFormMessage({
  name,
  email,
  phone,
  projectType,
  projectDescription,
  timeSlot,
}) {
  return `Hello GoToBusiness,

I would like to discuss a project.

*Name:* ${name}
*Email:* ${email}
*Phone:* ${phone}
*Project Type:* ${projectType}
*Preferred Discussion Time:* ${timeSlot}

*Project Description:*
${projectDescription}`;
}
